import { Provider } from './provider';

export class StripeProvider extends Provider {
    
    PAYMENT_REQUEST_BUTTON_SUPPORTED_COUNTRIES: string[] = [
        'AE', 'AT', 'AU', 'BE', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK',
        'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HK', 'IE', 'IN', 'IT',
        'JP', 'LT', 'LU', 'LV', 'MX', 'MY', 'NL', 'NO', 'NZ', 'PH',
        'PL', 'PT', 'RO', 'SE', 'SG', 'SI', 'SK', 'US'];

    isPaymentRequestButtonCountrySupported(country: string) {
        return this.PAYMENT_REQUEST_BUTTON_SUPPORTED_COUNTRIES.indexOf(country) > -1;
    }

}
